export default {
  session: {
    img: 'https://web-data.zmlearn.com/image/jWWDepJQoKEuk2S2UaJtFB/img_banner_text%402x.png',
    button: 'https://web-data.zmlearn.com/image/mSD3y6V8zXSY2y7ZkDcUit/%E7%BC%96%E7%BB%84%208%402x.png'
  },
  howMuch: {
    title: '<h1>¿Cuánto cuesta la tutoría en línea de<span> AirClass</span>?</h1>',
    desc: 'El precio de las clases particulares puede variar por sesión, dependiendo del tipo y duración del plan de estudio. Por ejemplo, el costo de la tutoría de Física será más menor si compra un paquete con varias lecciones incluidas.'
  },
  onlyPay: {
    title: `<h1>Pagará  <span> solamente </span> por lo que gasta</h1>`,
    title1: `<h1>Always <span>flexible</span> and<p>&nbsp;reliable</p></h1>`,
    desc: `Puede decidir si quiere continuar con el programa de estudios de Airclass, después de tu primera sesión de prueba GRATUITA.
		No hay cuota de registro. `
  },
  risk: {
    title: `<h1>100% <span> libre de riesgo </span></h1>`,
    list: [
      {
        id: 1,
        title: 'Control de calidad',
        content: `Todos los tutores han aprobado nuestros procesos de admisión y formación.`,
        backgroundColor: '#FF8395',
        icon: ['#32C095', '#FFC452'],
        img: 'https://web-data.zmlearn.com/image/aTnazj4xbyw5xzJ4iMmQJX/icon_home_part7_pink%402x.png'

      },
      {
        id: 2,
        title: 'Reemplazo del tutor/a',
        content: 'Siempre encontramos un reemplazo (del tutor/a) adecuado en el menor plazo posible.',
        backgroundColor: '#70B2FA',
        icon: ['#FF8395', '#FFC452'],
        img: 'https://web-data.zmlearn.com/image/weC7D4eHds6pH2Dv5E5hE8/icon_home_part7_green%402x.png'
      },
      {
        id: 3,
        title: 'Pagos y Reembolsos',
        content: 'Todos los métodos de pago comunes están disponibles y posibles reembolsos se harán dentro de los 14 días despues de realizado el pago.',
        backgroundColor: '#2EC89A',
        icon: ['#48B4FF', '#FF8395'],
        img: 'https://web-data.zmlearn.com/image/eFdK7FvHvCnGJGkPxj36Rt/icon_home_part7_yellow%402x.png'
      },
      {
        id: 4,
        title: 'Seguridad',
        content: 'Todos los datos e información personal (vuestros) están 100% seguros con nosotros.',
        backgroundColor: '#FFC452',
        icon: ['#32C095'],
        img: 'https://web-data.zmlearn.com/image/2YNrSHMR3gY8V7HDczyZcn/icon_home_part7_blue%402x.png'
      }
    ]
  },

  comments: {
    title: `<h1>Es<p>&nbsp;altamente&nbsp;</p><span>&nbsp;recomendado&nbsp;</span>por nuestros padres y estudiantes</h1>`,
    excellent: 'Excelente',
    reviews: 'Basado en 2.809 reseñas',
    list: [
      {
        id: 1,
        name: `Rocio Rodriguez Castilla`,
        date: '9 de enero de 2022',
        content: `A mi hija no se le dan bien las matemáticas, sin embargo, aprende rápido con Simon. Estoy muy contento con lo mucho que ha aprendido en tan poco tiempo. ¡Es una buena tutora de matemáticas!`
      },
      {
        id: 2,
        name: `Rosmery Valencia Rojas`,
        date: '15 de enero de 2022',
        content: `Ezequiel es un tutor excelente y siempre está listo para ayuda a mi hijo. Así que estoy muy contenta con él.`
      },
      {
        id: 3,
        name: `Isabel Antonia Alonso Forneron`,
        date: '14 de enero de 2022',
        content: `De hecho, todos los tutores que se le asignaron a mis hijos son geniales. No solo son pacientes, sino que también son buenos para comunicarse con los niños. Además, siempre puedo ponerme en contacto con ellos si es necesario.`
      }, {
        id: 4,
        name: `Amparo Hernandez`,
        date: '9 de enero de 2022',
        content: `Mi hijo empezó la clase de física con su tutora Alison hace un mes. Te puedo decir que estoy muy contenta del servicio de Alison. Mi hijo ha tenido mejor evaluación en el examen de física de la escuela. Alison siempre está a la disposición y muy paciente! se la recomendaré a todos.`
      },
      {
        id: 5,
        name: `Lorena Garzón`,
        date: '7 de enero de 2022',
        content: `Ellie es un tutor excelente quien es también muy amable y fácil de conversar. con ella a mi hijo se le va aumentando el interés en el estudio y la autoconfianza. Se ha mejorado mucho su psicología de nivel A y empezó a creer que puede alcanzar su meta. Le recomiendo sinceramente a Ellie como tutor de Psicología. `
      },
      {
        id: 6,
        name: `Verónica Guaman`,
        date: '19 de diciembre de 2021',
        content: `Mejoró mis notas de matematicas dentro un mes con la ayuda de mi tutora, Michelle. Es un excelente escuela online. Lo recomendaría a todos que estén dispuestos a invertir su tiempo y dinero para mejorar su futuro (especialmente para los de la universidad)`
      }
    ]
  },
  faqs: {
    title: `<h1><span>Preguntas frecuentes</span>  costos de tutoría y otros</h1>`,
    q: 'P',
    list: [
      {
        question: '¿Cómo funciona la tutoría de AirClass?',
        answer: `Paso 1: Evaluación inicial <br/>
				Durante la primera llamada, definiremos las necesidades del/ de la estudiante y elegiremos un/a tutor/a ideal para él/ella en función de las calificaciones, el carácter y los requisitos de cada uno. <br/>
				Paso 2: Lección de prueba gratuita <br/>
				En una lección de prueba, puede familiarizarse con AirClass sin ningún compromiso. El/La tutor/a evaluará la situación inicial y desarrollará un plan de aprendizaje personal junto con usted. A través de la lección de prueba, puede realizar solicitudes más específicas para futuros cursos.  <br/>
				Paso 3: Establecimiento de metas <br/>
				En esta fase, definiremos los objetivos del estudiante y descubriremos la mejor manera de lograrlos juntos. <br/>
				Paso 4: comience nuestra tutoría en línea 1 a 1 <br/>
				Una vez que hayas comenzado tu curso, nuestro/a consultor/a de curso te ayudará a planificar todo lo que necesites. Puede pedirle que lo ayude a programar su lección, cambiar fechas de las lecciones, cancelar lecciones o cualquier otra necesidad.
				`
      },
      {
        question: '¿Puedo cambiar de mi tutor/a?',
        answer: 'Si su tutor/a no es adecuado por algún motivo, puede cambiar de tutor/a en cualquier momento.'
      },
      {
        question: '¿Qué opciones de pago están disponibles?',
        answer: 'Puede pagar la tutoría fácilmente mediente diversas formas de pago, tal como tranferencia bancaria, PayPal, Google Pay, Stripe, AllinPay y Alipay.'
      }
    ]
  }
};
